import { DocumentTemplateDataSourceApiKey } from 'primary-schema';
import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
/**
 * @deprecated This is moving to {@link FlowGenerateFileBlock} (except CombinePdf, that's going to FileConversionBlock)
 */
export var FlowGenerateDocumentMode;
(function (FlowGenerateDocumentMode) {
    FlowGenerateDocumentMode["DocumentTemplate"] = "DocumentTemplate";
    FlowGenerateDocumentMode["Markdown"] = "Markdown";
    FlowGenerateDocumentMode["CombinePdf"] = "CombinePdf";
})(FlowGenerateDocumentMode || (FlowGenerateDocumentMode = {}));
/* eslint-disable @typescript-eslint/no-deprecated -- the block schema must reference its own deprecated mode enum while those modes remain supported */
export const FlowDocumentTemplateBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.DocumentTemplate),
    config: z.discriminatedUnion('generateDocumentMode', [
        z.object({
            generateDocumentMode: z.literal(FlowGenerateDocumentMode.DocumentTemplate),
            documentTemplateId: z.uuid(),
            valuesByDocumentTemplateKey: z.partialRecord(z.enum(DocumentTemplateDataSourceApiKey), z.string().optional()),
        }),
        z.object({
            generateDocumentMode: z.literal(FlowGenerateDocumentMode.Markdown),
            markdown: z.string(),
        }),
        z.object({
            generateDocumentMode: z.literal(FlowGenerateDocumentMode.CombinePdf),
            fileReferences: z.string(),
        }),
    ]),
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.FileReference),
});
//# sourceMappingURL=config.js.map